import api from './apiLibrary';

const API = {
    getStatus() {
        return api.get('/api/admin/sms-gateway');
    },
    getOutages() {
        return api.get('/api/admin/sms-gateway/outages');
    },
};

export default API;
